const useServerCustomHeader = ( props:{ key:string, storageKey:string }[] ) => {

    const armadorStaticPayload = document?.getElementById('ARMADORStaticPayload')?.textContent;
    const _armadorStaticPayload = JSON.parse(armadorStaticPayload||"");
    
    for ( let item of props ) {
        if ( _armadorStaticPayload?.[item.key] ) localStorage.setItem(item.storageKey, _armadorStaticPayload?.[item.key]);
    }

    return true;
}

export default useServerCustomHeader;